module.exports = __webpack_public_path__ + "img/mdh1.5f566f5e.jpg";